import autocomplete from 'assets/themes/campings/js/module/searchForm/autocomplete'
import calendar from 'assets/themes/campings/js/module/searchForm/calendar'
import events from 'assets/themes/campings/js/module/searchForm/events'
import maxDistance from 'assets/themes/campings/js/module/searchForm/maxDistance'
import menus from 'assets/themes/campings/js/module/searchForm/menus'
import travelerSelector from 'assets/themes/campings/js/module/searchForm/travelerSelector'

export default function (): void {
  calendar()
  autocomplete()
  events()
  menus()
  maxDistance()
  travelerSelector()
}
